import { useCallback, useRef } from "react";

const TWO_HOURS_MS = 2 * 60 * 60 * 1000;

async function fetchServerVersion(): Promise<string> {
  const res = await fetch("/version", { signal: AbortSignal.timeout(5000) });
  if (!res.ok) throw new Error();
  const { version } = await res.json();
  return version;
}

export function useVersionCheck() {
  const lastCheckedAt = useRef<number>(Date.now());
  const isStaleRef = useRef(false);

  const shouldBlock = useCallback((): boolean => {
    return (
      isStaleRef.current || Date.now() - lastCheckedAt.current >= TWO_HOURS_MS
    );
  }, []);

  const checkVersion = useCallback(async (): Promise<boolean> => {
    if (isStaleRef.current) return true;
    if (Date.now() - lastCheckedAt.current < TWO_HOURS_MS) return false;
    try {
      const serverVersion = await fetchServerVersion();
      lastCheckedAt.current = Date.now();
      const stale = serverVersion !== __VERSION__;
      isStaleRef.current = stale;
      return stale;
    } catch {
      return false;
    }
  }, []);

  return { shouldBlock, checkVersion };
}
